"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 100,
      'letterSpacing': 0,
      'lineHeightPx': 100,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 425,
        'y': -332,
        'width': 900,
        'height': 100
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 40,
      'letterSpacing': 0,
      'lineHeightPx': 48,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 425,
        'y': -244,
        'width': 900,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 12,
      'letterSpacing': 0,
      'lineHeightPx': 18,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 329,
        'y': 153.8875732421875,
        'width': 193,
        'height': 18
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 329,
        'y': 176.8875732421875,
        'width': 193,
        'height': 42
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 329,
        'y': 223.8875732421875,
        'width': 193,
        'height': 20
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': 329,
        'y': -151,
        'width': 193,
        'height': 289.8875427246094
      },
      'children': [{
        'id': '760:2895',
        'name': 'Image',
        'type': 'INSTANCE',
        'blendMode': 'PASS_THROUGH',
        'children': [{
          'id': 'I760:2895;141:323',
          'name': 'image',
          'type': 'RECTANGLE',
          'blendMode': 'PASS_THROUGH',
          'absoluteBoundingBox': {
            'x': 329,
            'y': -151,
            'width': 193,
            'height': 289.8875427246094
          },
          'constraints': {
            'vertical': 'SCALE',
            'horizontal': 'SCALE'
          },
          'fills': [{
            'blendMode': 'NORMAL',
            'type': 'IMAGE',
            'scaleMode': 'FILL',
            'imageRef': '6698a6750b4063c6a235f4219b4cc4bb269fa0e7'
          }],
          'strokes': [],
          'strokeWeight': 1,
          'strokeAlign': 'INSIDE',
          'effects': []
        }, {
          'id': 'I760:2895;846:15566',
          'name': 'FPO Overlay',
          'visible': false,
          'type': 'INSTANCE',
          'blendMode': 'PASS_THROUGH',
          'children': [{
            'id': 'I760:2895;846:15566;844:18328',
            'name': 'overlay-background',
            'type': 'RECTANGLE',
            'blendMode': 'PASS_THROUGH',
            'opacity': 0.20000000298023224,
            'absoluteBoundingBox': {
              'x': 329,
              'y': -151,
              'width': 249,
              'height': 374
            },
            'constraints': {
              'vertical': 'SCALE',
              'horizontal': 'SCALE'
            },
            'fills': [{
              'blendMode': 'NORMAL',
              'type': 'SOLID',
              'color': {
                'r': 1,
                'g': 1,
                'b': 1,
                'a': 1
              }
            }],
            'strokes': [],
            'strokeWeight': 1,
            'strokeAlign': 'INSIDE',
            'styles': {
              'fill': '387:74'
            },
            'effects': []
          }, {
            'id': 'I760:2895;846:15566;844:18329',
            'name': 'FPO',
            'type': 'VECTOR',
            'blendMode': 'PASS_THROUGH',
            'absoluteBoundingBox': {
              'x': 359,
              'y': 162,
              'width': 80,
              'height': 30.7886905670166
            },
            'preserveRatio': true,
            'constraints': {
              'vertical': 'BOTTOM',
              'horizontal': 'LEFT'
            },
            'fills': [{
              'blendMode': 'NORMAL',
              'type': 'SOLID',
              'color': {
                'r': 1,
                'g': 0.35873568058013916,
                'b': 0.9358733296394348,
                'a': 1
              }
            }],
            'strokes': [],
            'strokeWeight': 1,
            'strokeAlign': 'OUTSIDE',
            'effects': []
          }],
          'absoluteBoundingBox': {
            'x': 329,
            'y': -151,
            'width': 193,
            'height': 289.8875427246094
          },
          'constraints': {
            'vertical': 'SCALE',
            'horizontal': 'SCALE'
          },
          'clipsContent': false,
          'background': [{
            'blendMode': 'NORMAL',
            'visible': false,
            'type': 'SOLID',
            'color': {
              'r': 1,
              'g': 1,
              'b': 1,
              'a': 1
            }
          }],
          'fills': [{
            'blendMode': 'NORMAL',
            'visible': false,
            'type': 'SOLID',
            'color': {
              'r': 1,
              'g': 1,
              'b': 1,
              'a': 1
            }
          }],
          'strokes': [],
          'strokeWeight': 1,
          'strokeAlign': 'INSIDE',
          'backgroundColor': {
            'r': 0,
            'g': 0,
            'b': 0,
            'a': 0
          },
          'effects': [],
          'componentId': '900:1575'
        }],
        'absoluteBoundingBox': {
          'x': 329,
          'y': -151,
          'width': 193,
          'height': 289.8875427246094
        },
        'preserveRatio': true,
        'constraints': {
          'vertical': 'TOP',
          'horizontal': 'LEFT'
        },
        'clipsContent': false,
        'background': [],
        'fills': [],
        'strokes': [],
        'strokeWeight': 1,
        'strokeAlign': 'INSIDE',
        'backgroundColor': {
          'r': 0,
          'g': 0,
          'b': 0,
          'a': 0
        },
        'effects': [],
        'componentId': '900:1585'
      }]
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1850,
        'y': -362,
        'width': 708,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1850,
        'y': -284,
        'width': 708,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 12,
      'letterSpacing': 0,
      'lineHeightPx': 18,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1850,
        'y': 110,
        'width': 196,
        'height': 18
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 12,
      'letterSpacing': 0,
      'lineHeightPx': 18,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1850,
        'y': 132,
        'width': 196,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 12,
      'letterSpacing': 0.18,
      'lineHeightPx': 20,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.125490203499794,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1850,
        'y': 173,
        'width': 196,
        'height': 21
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': 1850,
        'y': -199,
        'width': 196,
        'height': 294
      },
      'children': []
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2840,
        'y': -364,
        'width': 327,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2840,
        'y': -286,
        'width': 327,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 12,
      'letterSpacing': 0,
      'lineHeightPx': 18,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2840,
        'y': 9.992919921875,
        'width': 140,
        'height': 18
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 12,
      'letterSpacing': 0,
      'lineHeightPx': 18,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2840,
        'y': 31.992919921875,
        'width': 140,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2840,
        'y': 72.992919921875,
        'width': 140,
        'height': 20
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': 2840,
        'y': -215.5,
        'width': 140,
        'height': 210.49295043945312
      },
      'children': [{
        'id': '760:3766',
        'name': 'Image',
        'type': 'INSTANCE',
        'blendMode': 'PASS_THROUGH',
        'children': [{
          'id': 'I760:3766;141:323',
          'name': 'image',
          'type': 'RECTANGLE',
          'blendMode': 'PASS_THROUGH',
          'absoluteBoundingBox': {
            'x': 2840,
            'y': -215.5,
            'width': 140,
            'height': 210.49295043945312
          },
          'constraints': {
            'vertical': 'SCALE',
            'horizontal': 'SCALE'
          },
          'fills': [{
            'blendMode': 'NORMAL',
            'type': 'IMAGE',
            'scaleMode': 'FILL',
            'imageRef': '6698a6750b4063c6a235f4219b4cc4bb269fa0e7'
          }],
          'strokes': [],
          'strokeWeight': 1,
          'strokeAlign': 'INSIDE',
          'effects': []
        }, {
          'id': 'I760:3766;846:15566',
          'name': 'FPO Overlay',
          'visible': false,
          'type': 'INSTANCE',
          'blendMode': 'PASS_THROUGH',
          'children': [{
            'id': 'I760:3766;846:15566;844:18328',
            'name': 'overlay-background',
            'type': 'RECTANGLE',
            'blendMode': 'PASS_THROUGH',
            'opacity': 0.20000000298023224,
            'absoluteBoundingBox': {
              'x': 2840,
              'y': -215.5,
              'width': 249,
              'height': 374
            },
            'constraints': {
              'vertical': 'SCALE',
              'horizontal': 'SCALE'
            },
            'fills': [{
              'blendMode': 'NORMAL',
              'type': 'SOLID',
              'color': {
                'r': 1,
                'g': 1,
                'b': 1,
                'a': 1
              }
            }],
            'strokes': [],
            'strokeWeight': 1,
            'strokeAlign': 'INSIDE',
            'styles': {
              'fill': '387:74'
            },
            'effects': []
          }, {
            'id': 'I760:3766;846:15566;844:18329',
            'name': 'FPO',
            'type': 'VECTOR',
            'blendMode': 'PASS_THROUGH',
            'absoluteBoundingBox': {
              'x': 2870,
              'y': 97.5,
              'width': 80,
              'height': 30.7886905670166
            },
            'preserveRatio': true,
            'constraints': {
              'vertical': 'BOTTOM',
              'horizontal': 'LEFT'
            },
            'fills': [{
              'blendMode': 'NORMAL',
              'type': 'SOLID',
              'color': {
                'r': 1,
                'g': 0.35873568058013916,
                'b': 0.9358733296394348,
                'a': 1
              }
            }],
            'strokes': [],
            'strokeWeight': 1,
            'strokeAlign': 'OUTSIDE',
            'effects': []
          }],
          'absoluteBoundingBox': {
            'x': 2840,
            'y': -215.5,
            'width': 140,
            'height': 210.49295043945312
          },
          'constraints': {
            'vertical': 'SCALE',
            'horizontal': 'SCALE'
          },
          'clipsContent': false,
          'background': [{
            'blendMode': 'NORMAL',
            'visible': false,
            'type': 'SOLID',
            'color': {
              'r': 1,
              'g': 1,
              'b': 1,
              'a': 1
            }
          }],
          'fills': [{
            'blendMode': 'NORMAL',
            'visible': false,
            'type': 'SOLID',
            'color': {
              'r': 1,
              'g': 1,
              'b': 1,
              'a': 1
            }
          }],
          'strokes': [],
          'strokeWeight': 1,
          'strokeAlign': 'INSIDE',
          'backgroundColor': {
            'r': 0,
            'g': 0,
            'b': 0,
            'a': 0
          },
          'effects': [],
          'componentId': '900:1575'
        }],
        'absoluteBoundingBox': {
          'x': 2840,
          'y': -215.5,
          'width': 140,
          'height': 210.49295043945312
        },
        'preserveRatio': true,
        'constraints': {
          'vertical': 'TOP',
          'horizontal': 'LEFT'
        },
        'clipsContent': false,
        'background': [],
        'fills': [],
        'strokes': [],
        'strokeWeight': 1,
        'strokeAlign': 'INSIDE',
        'backgroundColor': {
          'r': 0,
          'g': 0,
          'b': 0,
          'a': 0
        },
        'effects': [],
        'componentId': '900:1585'
      }]
    }
  }
};
exports.default = _default;